export default {
  "content": "<path d=\"M6.25 3.125H5c-1.036 0-1.875.84-1.875 1.875v1.25M13.75 3.125H15c1.035 0 1.875.84 1.875 1.875v1.25m0 7.5V15c0 1.035-.84 1.875-1.875 1.875h-1.25m-7.5 0H5A1.875 1.875 0 013.125 15v-1.25M12.5 10a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z\" stroke=\"var(--Primary-Text-Color)\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none"
  }
};